module.exports = __webpack_public_path__ + "img/tywg-btn.3ae38f44.webp";